var _a;
import { createStore, compose, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { createMemoryHistory } from 'history';
import { routerMiddleware } from 'connected-react-router';
import { createRootReducer } from './reducers';
export const history = createMemoryHistory();
const composeEnhancers = process.env.NODE_ENV === 'production' ? compose : (_a = Reflect.get(window, '__REDUX_DEVTOOLS_EXTENSION_COMPOSE__')) !== null && _a !== void 0 ? _a : compose;
export const configureStore = () => createStore(createRootReducer(history), undefined, composeEnhancers(applyMiddleware(routerMiddleware(history), // connected-react-router
thunk)));
